import { createContext, useEffect, useState } from "react"
import { onAuthStateChanged } from "firebase/auth"
import {
    doc,
    getDoc, 
} from "firebase/firestore"
import { db, auth } from "../firebase"

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState()
    const [authUser, setAuthUser] = useState()
    const [loading, setLoading] = useState(true)

    console.log(loading)
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setAuthUser(user)
                console.log("getting user data")
                await getDoc(doc(db,"users", user.uid))
                .then(userInfo => {
                    const userInfoData = userInfo.data()
                    user.avatarUrl = userInfoData.avatarUrl
                    user.firstName = userInfoData.firstName
                    user.lastName = userInfoData.lastName
                    // user.activeChats = userInfoData.activeChats
                    // user.activeBids = userInfoData.activeBids
                    // user.address = userInfoData.addressData ? userInfoData.addressData.formattedAddress : null
                    // user.coordinates = userInfoData.addressData ? userInfoData.addressData.coordinates : null
                    // user.birthday = userInfoData.birthday
                    // setCurrentUser({...user})
                })
                await getDoc(doc(db,`users/${user.uid}/private`, "data"))
                .then(privateInfo => {
                    const privateInfoData = privateInfo.data()
                    user.activeChats = privateInfoData.activeChats
                    user.activeBids = privateInfoData.activeBids
                    user.address = privateInfoData.addressData ? privateInfoData.addressData.formattedAddress : null
                    user.coordinates = privateInfoData.addressData ? privateInfoData.addressData.coordinates : null
                    user.birthday = privateInfoData.birthday
                    user.notificationSettings = privateInfoData.notificationSettings
                    // setCurrentUser({...user})
                })

                setCurrentUser({...user})
            }
            setLoading(false)
        })

        return () => {
            unsub()
        }
    }, [])

    const logout = () => {
        return auth.signOut()
    }

    const value = {
        currentUser,
        authUser,
        logout
    }

    return (
        <AuthContext.Provider value={ value }>
            {!loading && children}
        </AuthContext.Provider>
    )

}